import React from 'react';

import { i18n } from '../i18n';

import hotLogo from './images/hot-logo.png';
import pofLogo from './images/pof-logo.png';

import css from './index.module.css';

export default class HotPof extends React.Component {
    constructor(props) {
        super();
    }

    render() {
        return (
            <div className={css.hotpof} id="hotpof">
                <div className={css.container}>
                    <div className={css.logos}>
                        <img className={css.hot} src={hotLogo} alt="Heart of Thorns" />
                        <img className={css.pof} src={pofLogo} alt="Path of Fire" />
                    </div>
                    <h2 className={css.header}>{i18n('hotpof.header')}</h2>
                    <p className={css.desc}>{i18n('hotpof.desc')}</p>
                    <a
                        className={css.button}
                        href={i18n('hotpof.buyLink', true)}
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        {i18n('hotpof.cta')}
                    </a>
                </div>
            </div>
        );
    }
}
